const apiStringServer = 'https://ksgc-server.kintelligence.com.br:3360';
//const apiStringServer = 'http://localhost:3061';

export default apiStringServer;